import { render, staticRenderFns } from "./Essential.vue?vue&type=template&id=61b9ec95&scoped=true"
import script from "./Essential.vue?vue&type=script&lang=js"
export * from "./Essential.vue?vue&type=script&lang=js"
import style0 from "./Essential.vue?vue&type=style&index=0&id=61b9ec95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b9ec95",
  null
  
)

export default component.exports